var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tour',{attrs:{"name":"sortTour","callbacks":_vm.callbacks,"enabled":_vm.enabled,"options":_vm.options,"steps":_vm.applicableSteps}})}
var staticRenderFns = []

export { render, staticRenderFns }